export const Signup_S='s/s';
export const Signup_L='s/l';
export const Signup_E='s/e';

export const Login_S='l/s';
export const Login_L='l/l';
export const Login_E='l/e';
